Apt.fn.extend('account.profile', {}, {
	/**
	 * Initialize professional profile form toggle
	 */
	initToggle() {
		const scope = this;

		$$('professional').on('change', (e, el) => {
			if (el.checked) {
				scope.initExtended();
			}
		}, {
			init: true,
			namespace: 'profile'
		});
	},

	/**
	 * Initialize extended profile
	 */
	initExtended() {
		const scope = this;

		scope.locators = [];

		if (scope.extended) {
			return;
		}

		scope.extended = true;

		scope.initLocation();

		requestAnimationFrame(() => {
			$('textarea', '$detail').resize('profile');
		});

		if ($.app.profile.$get('promoted') && $.app.profile.$get('data.profile.type') === 'agent') {
			scope.initServiceAreas();
		}

		scope.initDesignations();
		scope.initLicenses();
	},

	/**
	 * Initialize location
	 */
	initLocation() {
		const scope = this;
		const near = data => selection || data.center;

		let selection;

		scope.positioned = scope.id;
		scope.precision = 0;

		LS.util.load('maps', () => {
			scope.pinpoint();
		});

		scope.locality = Apt.fn.locator()
			.init('$profileLocality', {
				id: true,
				type: 'localities',
				center: near,
				changed: value => {
					selection = value.slug;

					$.app.profile.$set('data.locality', value);

					if (scope.precision < 2) {
						scope.precision = 1;

						LS.location.entry(value.slug, data => {
							if (! scope.positioned) {
								scope.setPosition(data.center);
							}
						});
					}
				}
			});

		scope.address = Apt.fn.locator()
			.init('$profileAddress', {
				type: 'address',
				key: 'name',
				center: () => scope.center,
				changed: value => {
					if (scope.precision < 4) {
						scope.precision = 3;

						if (! scope.positioned) {
							scope.setPosition(value.center, 14);
						}
					}

					if (! value.feature) {
						return;
					}

					let locality;
					let postal;

					value.feature.context.forEach(item => {
						if (item.id.startsWith('place')) {
							locality = item.text;
						} else if (item.id.startsWith('region')) {
							locality += item.short_code.replace('US-', ' ');
						} else if (item.id.startsWith('postcode')) {
							postal = item.text;
						}
					});

					if (locality && ! $.app.profile.$get('data.locality_id')) {
						LS.location.entry(LS.util.slugify(locality), data => {
							scope.locality.set(data);

							$.app.profile.$set('data.locality', data);
						});
					}

					if (postal && ! $.app.profile.$get('data.postal_code_id')) {
						LS.location.entry(postal, data => {
							scope.postal.set(data);

							$.app.profile.$set('data.postal_code', data);
						});
					}
				}
			});

		scope.postal = Apt.fn.locator()
			.init('$profilePostal', {
				id: true,
				type: 'postal_codes',
				center: near,
				changed: value => {
					selection = value.slug;

					if (scope.precision < 3) {
						scope.precision = 2;

						LS.location.entry(value.slug, data => {
							if (! scope.positioned) {
								scope.setPosition(data.center, 12);
							}
						});
					}
				}
			});
	},

	/**
	 * Initialize service areas
	 */
	initServiceAreas() {
		const scope = this;
		const key = 'data.service_areas';
		const options = {
			type: [
				'localities',
				'postal_codes',
				'subterritories'
			],
			center: () => $.app.profile.$get('data.profile.locality.slug')
		};

		$.app.profile.$get(key, []).forEach(el => {
			scope.locators['area-' + el.id] = Apt.fn.locator()
				.init('$serviceArea' + el.id, options);
		});

		$.events.on({
			'$addServiceArea': {
				click: () => {
					const uid = LS.util.uid();

					$.app.profile.$push(key, {
						uid: uid
					});

					scope.locators['area-' + uid] = Apt.fn.locator()
						.init('$serviceArea' + uid, options);
				}
			},
			'$deleteServiceArea': {
				click: (e, el) => {
					const $parent = $(el).parent();

					scope.locators[$parent.data('uid')].$destroy();

					$.app.profile.$drop(key + '.' + $parent.index());
				}
			}
		}, {
			delegate: scope.$form,
			namespace: 'profile'
		});
	},

	/**
	 * Initialize designations
	 */
	initDesignations() {
		const key = 'data.designations';

		$.events.on({
			'$addDesignation': {
				click: () => {
					$.app.profile.$push(key, {});
				}
			},
			'$deleteDesignation': {
				click: (e, el) => {
					$.app.profile.$drop(key + '.' + $(el).parent().index());
				}
			}
		}, {
			delegate: this.$form,
			namespace: 'profile'
		});
	},

	/**
	 * Initialize licenses
	 */
	initLicenses() {
		const scope = this;
		const key = 'data.licenses';
		const options = {
			id: true,
			type: [
				'territories'
			],
			center: () => $.app.profile.$get('data.profile.locality.slug')
		};

		$.app.profile.$get(key, []).forEach(el => {
			scope.locators['license-' + el.id] = Apt.fn.locator()
				.init('$licenseTerritory' + el.id, options);
		});

		$.events.on({
			'$addLicense': {
				click: () => {
					const uid = LS.util.uid();

					$.app.profile.$push(key, {
						uid: uid
					});

					scope.locators['license-' + uid] = Apt.fn.locator()
						.init('$licenseTerritory' + uid, options);
				}
			},
			'$deleteLicense': {
				click: (e, el) => {
					const $parent = $(el).parent();

					scope.locators[$parent.data('uid')].$destroy();

					$.app.profile.$drop(key + '.' + $parent.index());

					// Reindex location input names
					document.querySelectorAll('input[name^="licenses["][name$="][territory_id]"]')
						.forEach((input, index) => {
							input.name = input.name.replace(/\[\d+]/, `[${index}]`);
						});
				}
			}
		}, {
			delegate: scope.$form,
			namespace: 'profile'
		});
	}
});